import { connect } from 'react-redux';
import { environmentSelectors, localizationSelectors } from '@lifesize/nucleus';
import { localizationUtils } from '@lifesize/clients.localization';
import { openHelpDesktop } from 'actions/Header';
import Help from 'components/Header/Help';

const mapStateToProps = (state) => {
  const localization = localizationSelectors.localization(state);
  const helpPageUrl = localizationUtils.getHelpPage(localization.languageId);

  return {
    helpPageUrl,
    isDesktop: environmentSelectors.platform(state).isDesktop
  };
};

const mapDispatchToProps = (dispatch) => ({
  desktopOpenHelp: (url) => {
    dispatch(openHelpDesktop(url));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Help);
